import { useState, useEffect } from 'react';
import animationStyles from "@netapp/bxp-design-system-react/styles/SlidingMenu/animationStyles.module.scss";

export function useFlyoutAnimation(isOpen, isAnimationFinished) {
    const [showFlyout, setShowFlyout] = useState(false);
    const [isFlyoutFullyOpen, setIsFlyoutFullyOpen] = useState(false);
    const [flyoutAnimationClass, setFlyoutAnimationClass] = useState('');

    useEffect(() => {
        let enterTimer, exitTimer, hideTimer;
        if (isOpen && isAnimationFinished) {
            setShowFlyout(true);
            setFlyoutAnimationClass(animationStyles['enter-from-left']);
            enterTimer = setTimeout(() => {
                setFlyoutAnimationClass(animationStyles['enter-from-left-active']);
                setIsFlyoutFullyOpen(true);
            }, 30);
        } else if (!isOpen && showFlyout) {
            setFlyoutAnimationClass(animationStyles['exit-from-left']);
            exitTimer = setTimeout(() => {
                setFlyoutAnimationClass(animationStyles['exit-from-left-active']);
            }, 10);
            hideTimer = setTimeout(() => {
                setShowFlyout(false);
                setFlyoutAnimationClass('');
                setIsFlyoutFullyOpen(false);
            }, 410);
        } else {
            setShowFlyout(false);
            setFlyoutAnimationClass('');
            setIsFlyoutFullyOpen(false);
        }
        return () => {
            clearTimeout(enterTimer);
            clearTimeout(exitTimer);
            clearTimeout(hideTimer);
        };
    }, [isOpen, isAnimationFinished, showFlyout]);

    return { showFlyout, flyoutAnimationClass, isFlyoutFullyOpen };
}